import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import _ from 'lodash'
import moment from 'moment'
import { numberFormat, toBuddhistYear } from 'utils/app.utils'
import { forceTextOnDateCells } from 'utils/excel.utils'

async function ExportToExcel({
    data,
    branchName,
    rangeDate,
    billStatus,
    t,
}: {
    data: any[]
    branchName: string
    rangeDate: string[]
    billStatus: string
    t: any
}) {
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet(t('REPORT.REPORT_NAME.ADVANCE_DECREASE'))

    // Title
    const titleRow = sheet.addRow([t('REPORT.REPORT_NAME.ADVANCE_DECREASE')])
    titleRow.font = { bold: true, size: 16 }
    sheet.mergeCells(titleRow.number, 1, titleRow.number, 12)
    titleRow.alignment = { horizontal: 'left' }

    // Filters
    const filterRow = sheet.addRow([
        `${t('REPORT.TABLE.DECREASE.BRANCH')}: ${branchName || '-'}`,
        `${t('REPORT.TABLE.DECREASE.DATE_START')}: ${toBuddhistYear(moment(rangeDate[0]), 'DD/MM/YYYY')}`,
        `${t('REPORT.TABLE.DECREASE.DATE_END')}: ${toBuddhistYear(moment(rangeDate[1]), 'DD/MM/YYYY')}`,
        `${t('REPORT.TABLE.DECREASE.STATUS')}: ${billStatus === 'ALL' ? t('REPORT.FILTER.ALL') : t(`REPORT.FILTER.BILL.${billStatus}`)}`
    ])
    filterRow.font = { size: 11 }
    sheet.mergeCells(filterRow.number, 1, filterRow.number, 12)
    filterRow.alignment = { horizontal: 'left' }

    // Head cells (from AdvanceDecreaseList)
    const headCells = [
        { label: t('REPORT.TABLE.DF.#NO'), width: 8 },
        { label: t('REPORT.TABLE.DECREASE.BRANCH'), width: 18 },
        { label: t('REPORT.TABLE.DECREASE.DATE_ADVANCE'), width: 16 },
        { label: t('REPORT.TABLE.DECREASE.BILL'), width: 16 },
        { label: t('REPORT.TABLE.DECREASE.STATUS'), width: 14 },
        { label: t('REPORT.TABLE.DECREASE.PATIENT_CN_NUMBER'), width: 16 },
        { label: t('REPORT.TABLE.DECREASE.BRANCH_CN_NUMBER'), width: 16 },
        { label: t('REPORT.TABLE.DECREASE.PATIENT_SN_CODE'), width: 16 },
        { label: t('REPORT.TABLE.DECREASE.PATIENT_NAME'), width: 22 },
        { label: t('REPORT.TABLE.DECREASE.TOTAL_BILL'), width: 14 },
        { label: t('REPORT.TABLE.DECREASE.TOTAL_DF'), width: 14 },
        { label: t('REPORT.TABLE.DECREASE.TOTAL_ADVANCE'), width: 14 },
    ]
    sheet.columns = headCells.map(c => ({ width: c.width }))
    const headerRow = sheet.addRow(headCells.map(c => c.label))
    headerRow.font = { bold: true, size: 12 }
    headerRow.alignment = { horizontal: 'left', vertical: 'middle' }

    // Data rows
    if (!data || data.length === 0) {
        const noDataRow = sheet.addRow([t('REPORT.TITLE.NO_DATA')])
        sheet.mergeCells(noDataRow.number, 1, noDataRow.number, headCells.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
    } else {
        data.forEach((row: any, idx: number) => {
            sheet.addRow([
                idx + 1,
                row.branchName || '-',
                row.createdAt ? moment(row.createdAt).format('DD/MM/YYYY HH:mm') : '-',
                row.paymentNumber || '-',
                t(`REPORT.TABLE.ADVANCE.STATUS.${row.statusOrder}`) || '-',
                row.cnNumber || '-',
                row.branchCnNumber || '-',
                row.snCode || '-',
                row.patientFullname || '-',
                numberFormat(row.totalPrice, 2),
                numberFormat(row.amountPaid, 2),
                numberFormat(row.amountAdvance, 2),
            ])
        })
        // Summary row (sum columns)
        const sumRow = sheet.addRow([
            '', '', '', '', t('REPORT.TITLE.SUM'), '', '', '', '',
            numberFormat(_.sumBy(data, 'totalPrice') || 0, 2),
            numberFormat(_.sumBy(data, 'amountPaid') || 0, 2),
            numberFormat(_.sumBy(data, 'amountAdvance') || 0, 2),
        ])
        sumRow.font = { bold: true }
        sumRow.alignment = { horizontal: 'right' }
        sheet.mergeCells(sumRow.number, 1, sumRow.number, 5)
    }

    // Save file
    forceTextOnDateCells(workbook)
    const buffer = await workbook.xlsx.writeBuffer()
    const timestamp = moment().format('YYYYMMDD_HHmmss')
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, `${t('REPORT.REPORT_NAME.ADVANCE_DECREASE')}_${timestamp}.xlsx`)
}

export default ExportToExcel 